import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';

const BuilderTextList = () => {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSearch = async () => {
    console.log('[BuilderTextList] handleSearch called with text:', text);

    if (!text.trim()) {
      setError('Please enter some text.');
      return;
    }
    
    const nonEmptyLines = text.split('\n').filter(line => line.trim() !== '');
    if (nonEmptyLines.length > 30) {
      setError('Maximum 30 non-empty lines allowed.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      console.log('[BuilderTextList] Fetching /search_tracks_from_text...');
      const response = await fetch('/search_tracks_from_text', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text }),
      });
      if (response.status === 401) {
        window.location.href = '/';
        return;
      }
      if (response.status === 400) {
        setError('Invalid input. Please check your text and try again.');
        setLoading(false);
        return;
      }
      if (response.status === 413) {
        setError('Input too long. Please shorten your text.');
        setLoading(false);
        return;
      }
      console.log('[BuilderTextList] Response status:', response.status);
      if (!response.ok) {
        const errorMsg = await response.text();
        setError('Server error: ' + (errorMsg || response.status));
        setLoading(false);
        return;
      }
      const data = await response.json();
      console.log('[BuilderTextList] Response data:', data);
      if (!Array.isArray(data)) {
        setError('Unexpected server response.');
        setLoading(false);
        return;
      }
      setLoading(false);
      navigate('/builder/search', { state: { songs: data } });
    } catch (err) {
      setError('Network error: ' + (err.message || err));
      setLoading(false);
    }
  };

  return (
    <div className="mb-3">
      <br/>
      <h1>Search Multiple Songs</h1>
      
      <label htmlFor="builder-text-search" className="form-label">Search Multiple Songs (Author | Song Name)</label>
      <textarea
        id="builder-text-search"
        className="form-control"
        rows={3}
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder="Author|Song Name"
        disabled={loading}
      />
      <div className="d-flex justify-content-center align-items-center mt-2">
        <Button variant="primary" onClick={handleSearch} disabled={loading || !text.trim()}>
          {loading ? 'Searching...' : 'Search'}
        </Button>
        {error && <span className="text-danger ms-3">{error}</span>}
      </div>
    </div>
  );
};

export default BuilderTextList;
